var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Link from "next/link";
export const ItemWrapper = (_a) => {
    var { isInternal = false, href } = _a, props = __rest(_a, ["isInternal", "href"]);
    if (href == null) {
        return _jsx("div", Object.assign({}, props));
    }
    if (isInternal) {
        return _jsx(Link, Object.assign({ href: href }, props));
    }
    const externalLinkProps = href.slice(0, 9) === "/courses/"
        ? props
        : Object.assign({ target: "_blank", rel: "noopener noreferrer" }, props);
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return _jsx("a", Object.assign({ href: href }, externalLinkProps));
};
//# sourceMappingURL=ItemWrapper.js.map